<template>

  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <div class="mt2 text-left">
         {{data.no_permohonan}} | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
      </div><br>
    <z-page title="MAKLUMAT PERMOHONAN" >  

      <div class="table_scrol">
      <table class="w-table" color="light" >

      <w-card bg-color="" class="">
        <w-form class="" v-model="data.valid" v-model:errors-count="data.errorsCount" @validate="onValidate" @success="onSuccess">
          <div class="w-flex wrap smd-column" >
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>Nama Penternak</b></td>
                     <td><b>:</b></td>
                     <td>{{data.user_nama}}</td>
                  </tr>

                  <tr class="row_data">
                     <td><b>Tarikh Mohon</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_mohon)}} / {{$zutil.formatDateToTime(data.tarikh_mohon)}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>ID Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_premis}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Tarikh Pengesanan Berahi</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_pengesanan_biang)}} / {{$zutil.formatMasa(data.masa_pengesanan_biang)}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>Nama Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_premis}}</td>
                  </tr>
                  
                  <tr class="row_data">
                     <td><b>Pasung</b></td>
                     <td><b>:</b></td>
                     <td>
                        <div v-if="data.pasung==1">Ada</div>
                        <div v-else>Tidak Ada</div>
                     </td>
                  </tr>
                  </tbody>
               </table>
              </div>
            </div>
            <!-- <w-flex justify-end class="mt2" v-if="(data.lkp_status_id==34 && data.pemeriksaan!=1) || data.lkp_status_id==32 || data.lkp_status_id==27">
                <w-button class="my1" :loading="data.submitted && !data.sent" type="success">
                  <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                </w-button>
            </w-flex> -->
         </w-form>
      </w-card>
      </table><br>
      <w-tabs :items="tabs" :no-slider="false" class="w-tabs" color="black" active-class="blue" slider-color="blue" v-model="activeTab" card>

        <template #item-content.1>
            <Pemeriksaan :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0" />
        </template>
        <template #item-content.2>
            <Perkhidmatan :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0" />
        </template>
        <template #item-content.3>
            <PemeriksaanAi :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
        </template>
        <template #item-content.4>
            <CajPerkhidmatan :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
        </template>
      </w-tabs>
      <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
// import Baka from './Sub/Baka.vue';
import Perkhidmatan from './Sub/Perkhidmatan.vue';
import Pemeriksaan from './Sub/Pemeriksaan.vue';
import CajPerkhidmatan from './Sub/CajPerkhidmatan.vue';
import PemeriksaanAi from './Sub/PemeriksaanAi.vue';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    VueQrcode, Pemeriksaan, Perkhidmatan, CajPerkhidmatan, PemeriksaanAi
  },
  props: {
    id: [Array, Object, String],
    segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: "art.ai",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Permohonan Perkhidmatan', route: '/art' },
        { label: 'AI SEMULAJADI', route: '/art/ai'},
        { label: 'Papar', route: '/art/ai/show'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      ternakan_list: [],
      activeTab : 0,
      jankaan_biang_semula:0,
      tabs: [
      		 { title: 'PEMERIKSAAN TERNAKAN', content: '' },
            { title: 'PROSEDUR AI', content: ''},
            { title: 'PEMERIKSAAN KEBUNTINGAN', content: ''},
            { title: 'SLIP PERKHIDMATAN', content: ''}
          ]
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },

    getData()
    {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get('tab');
      if(tab){
        this.activeTab = parseInt(tab) - 1;
      }
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
         this.data = res;
         // alert(this.data.tarikh_ai);
         if(this.data.tarikh_pemeriksaan!=null){
            this.tabs[1].disabled = false;
         }else{
            this.tabs[1].disabled = true;
         };
            this.jankaan_biang_semula = 0;
            const today = new Date();
            const hari_ini = today.toISOString().split('T')[0];
            this.data.ternakan_list.some((row) => {
               const biang_semula = row.jankaan_biang_semula;
               if(hari_ini>=biang_semula){
                  this.jankaan_biang_semula = 1;
                  return true;
               }else{
                  this.jankaan_biang_semula = 0;
                  return false;
               }
            });
        if(this.jankaan_biang_semula==1 && this.data.tarikh_ai!=null && (this.data.lkp_status_id == 39 || this.data.lkp_status_id == 27 ||  this.data.lkp_status_id == 40 || this.data.lkp_status_id == 18)){
          this.tabs[2].disabled = false;
        }else{
          this.tabs[2].disabled = true;
        }
        if(this.data.tarikh_ai!=null){
          this.tabs[3].disabled = false;
        }else{
          this.tabs[3].disabled = true;
        }
        if (this.data.tarikh_pemeriksaan == null && this.data.tarikh_laporan == null|| this.data.tarikh_laporan == '') {
          // var today = new Date();
          //  this.data.tarikh_pemeriksaan = today.toISOString().split('T')[0];
          //  this.data.tarikh_laporan = today.toISOString().split('T')[0];

        }
      })
    },
    onSuccess(){
        if (this.data.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.data.id, {tarikh_pemeriksaan:this.data.tarikh_pemeriksaan, tarikh_laporan:this.data.tarikh_laporan, save_tarikh_pemeriksaan:1})
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
              this.getData();
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.ai-aiman', this.data.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  margin-top: -12px;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}
tr b {
  position: relative;   
  display: inline-block;
  min-width: 10px;
  margin-right: 10px;
}
tr b:after {
  /*content: ":";*/
  position: absolute;
  right: 0;
}
   w-tabs .w-tab-item.active {
     background-color: blue !important;
     color: white !important;
     border-radius: 5px;
   }
   .w-tabs .w-tab-item[aria-selected="true"] {
  background-color: blue !important;
  color: white !important;
  border-radius: 5px;
}
   .tabs2 .w-tabs__bar .w-tabs__bar-item{
          padding : 1px 1px !important;
   }
   .green_tab{
      background-image: radial-gradient( circle 963px at 1.9% 5%,  rgba(0,193,80,1) 0%, rgba(0,112,198,1) 100.2% );
      padding: 12px 8px;
   }
</style>
